<template>
  <exo-help-dialog title="Tolerance Type">
    <b> Semi-major axis tolerance: </b> defines a box in sma in which the
    spacecraft must remain, <br />
    <b> Along-track tolerance:</b> defines a box in the along-track direction in
    which the spacecraft must remain.
  </exo-help-dialog>
</template>

<script>
export default {
  name: 'tooltipSKToleranceType'
}
</script>
